// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pickem/round-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePickemRoundGetBody,
  typePickemRoundGetOutput200,
} from "../../sdk/pickem/postPickemRoundGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPickemRoundGetQueryKey(
  payload: typePickemRoundGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.roundId !== "undefined") {
    queryKeySegments.push(`roundId:${JSON.stringify(payload.roundId)}`);
  }
  return ["post:pickem:pickemRoundGet", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePickemRoundGetOutput200,
    unknown,
    typePickemRoundGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePickemRoundGet(
  payload: typePickemRoundGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPickemRoundGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPickemRoundGet(payload),
    ...resolvedOptions,
  });
}
